
import { Vue, Component } from 'vue-property-decorator';
import { Field, Popup, Picker, DatetimePicker, Button, Toast } from 'vant';
import SyEditor from '@/components/SyEditor.vue';
import moment from 'moment';
import { update } from '../api';
Vue.use(Field)
  .use(Popup)
  .use(Picker)
  .use(DatetimePicker)
  .use(Button);
@Component({
  components: {
    SyEditor,
  },
})
export default class Home extends Vue {
  height: string = '300';
  title: string = '';
  link: string = '';
  platformColumns = ['wap', 'app'];
  platform: string = '';
  platformShow = false;
  mediaColumns = [
    '上游',
    '重庆日报',
    '华龙网',
    '重庆日报',
    '重庆日报',
    '重庆日报',
  ];
  media: string = '';
  mediaShow = false;
  reviewer: string = '';
  date: string = '';
  minDate = new Date(2020, 0, 1);
  maxDate = new Date(2025, 10, 1);
  current = new Date();
  currentDate = '请选择时间';
  dateShow = false;
  wrong: string = '';
  remark: string = '';
  editor: string = '';
  id: number = 0;
  mounted() {
    if (!localStorage.getItem('0420BMB_token')) {
      this.$router.push('login');
    }
    if (this.$route.params as any) {
      const data = this.$route.params as any;
      console.log(11111, data, this.$route);
      this.title = data.title ? data.title : '';
      this.link = data.link ? data.link : '';
      this.platform = data.platform ? data.platform : '';
      this.media = data.media ? data.media : '';
      this.reviewer = data.reviewer ? data.reviewer : '';
      this.editor = data.editor ? data.editor : '';
      this.wrong = data.wrong ? data.wrong : '';
      this.remark = data.remark ? data.remark : '';
      this.id = data.id;
    }
  }
  onConfirm(value: any) {
    this.platform = value;
    this.platformShow = false;
  }
  mediaConfirm(value: any) {
    this.media = value;
    this.mediaShow = false;
  }
  dateConfirm(value: any) {
    this.dateShow = false;
    this.currentDate = moment(value).format('YYYY-MM-D');
  }

  async submit() {
    if (!this.title) {
      Toast.fail('请填写标题！');
      return false;
    } else if (!this.media) {
      Toast.fail('请填写媒体！');
      return false;
    } else if (!this.reviewer) {
      Toast.fail('请填写审读人！');
      return false;
    } else if (!this.wrong) {
      Toast.fail('请填写差错描述！');
      return false;
    } else if (!this.remark) {
      Toast.fail('请填写处理意见！');
      return false;
    } else {
      const data = {
        token: localStorage.getItem('0420BMB_token'),
        title: this.title,
        link: this.link,
        platform: this.platform,
        media: this.media,
        wrong: this.wrong,
        remark: this.remark,
        reviewer: this.reviewer,
        editor: this.editor,
        id: this.id,
      };
      const res: any = await update(data);
      if (res.statusCode === 200) {
        console.log(123);
        Toast.success('修改成功！');
        setTimeout(() => {
          this.$router.go(-1);
        }, 1500);
      } else if (res.statusCode === 401) {
        Toast.fail(res.message);
        setTimeout(() => {
          this.$router.push('login');
        }, 1500);
      } else {
        Toast.fail(res.message);
      }
    }
  }
}
